import gql from "graphql-tag";

// This file holds shared fragments for the admin pages.

export const adminArticleFragment = gql`
  fragment AdminArticleFragment on Article {
    id
    status
    title
    youtubeVideoId
    context {
      id
      title
    }
    body {
      content
      isMarkdown
    }
    relevantContent {
      content
      isMarkdown
    }
  }
`;

export const adminFolderFragment = gql`
  fragment AdminFolderFragment on Folder {
    id
    status
    title
    type
    description {
      content
      isMarkdown
    }
  }
`;

export const adminMultipleChoiceFragment = gql`
  fragment AdminMultipleChoiceFragment on MultipleChoice {
    id
    type
    status
    title
    context {
      id
      title
    }
    ingress {
      content
      isMarkdown
    }
    relevantContent {
      content
      isMarkdown
    }
    questions {
      id
      title
      body {
        content
        isMarkdown
      }
      options {
        id
        title
        correct
      }
    }
  }
`;

export const adminMultipleChoiceQuestionOptionFragment = gql`
  fragment AdminMultipleChoiceQuestionOptionFragment on MultipleChoiceQuestionOption {
    id
    title
    correct
  }
`;

export const adminKurssloeyfeFragment = gql`
  fragment AdminKurssloeyfeFragment on Kurssloeyfe {
    id
    status
    title
    elements {
      parent {
        id
        title
      }
      id
      content {
        id
        status
        title
        ... on Article {
          youtubeVideoId
        }
      }
    }
  }
`;

export const adminFolderElementParentFragment = gql`
  fragment AdminFolderElementParentFragment on FolderElement {
    id
    parent {
      id
      title
    }
  }
`;

export const adminContentFragment = gql`
  fragment ContentFragment on Content {
    __typename
    id
    title
  }
`;

export const adminContentFolderElementFragment = gql`
  fragment ContentFolderFragment on FolderElement {
    id
    parent {
      id
      title
    }
    content {
      __typename
      id
      title
    }
  }
  ${adminContentFragment}
`;

export const adminFolderKurssloeyfeFragment = gql`
  fragment AdminFolderKurssloeyfeFragment on FolderElement {
    id
    content {
      ...ContentFragment
      ...AdminKurssloeyfeFragment
    }
  }
  ${adminContentFragment}
  ${adminKurssloeyfeFragment}
`;

export const adminKurssloeyfeElementParentFragment = gql`
  fragment AdminKurssloeyfeElementParentFragment on KurssloeyfeElement {
    id
    parent {
      id
      title
      folder {
        id
        title
      }
    }
  }
`;

export const adminKurssloeyfeArticleFragment = gql`
  fragment AdminKurssloeyfeArticleFragment on KurssloeyfeElement {
    id
    content {
      ...ContentFragment
      ...AdminArticleFragment
    }
  }
  ${adminContentFragment}
  ${adminArticleFragment}
`;

export const adminKurssloeyfeMultipleChoiceFragment = gql`
  fragment AdminKurssloeyfeMultipleChoiceFragment on KurssloeyfeElement {
    id
    content {
      ...ContentFragment
      ...AdminMultipleChoiceFragment
    }
  }
  ${adminContentFragment}
  ${adminMultipleChoiceFragment}
`;

export const adminFolderRootFragment = gql`
  fragment AdminFolderRootFragment on Folder {
    ...AdminFolderFragment
    elements {
      id
      content {
        id
        status
        title
        ... on Folder {
          type
        }
      }
    }
  }
  ${adminFolderFragment}
`;

export const adminFolderElementRootFragment = gql`
  fragment AdminFolderElementRootFragment on FolderElement {
    id
    parent {
      ...AdminFolderFragment
    }
    ... on FolderElement {
      ...ContentFolderFragment
    }
    content {
      ...ContentFragment
      ... on Kurssloeyfe {
        ...AdminKurssloeyfeFragment
      }
      ... on MultipleChoice {
        ...AdminMultipleChoiceFragment
      }
      ... on Article {
        ...AdminArticleFragment
      }
    }
  }
  ${adminContentFragment}
  ${adminArticleFragment}
  ${adminKurssloeyfeFragment}
  ${adminMultipleChoiceFragment}
  ${adminFolderFragment}
  ${adminContentFolderElementFragment}
`;

export const feedbackListFragment = gql`
  fragment FeedbackListFragment on Feedback {
    id
    messages {
      submittedAt
      submittedBy {
        id
      }
      body {
        isMarkdown
        content
      }
    }
    givenOn {
      ... on FeedbackGivenOnFolder {
        elementId
        folder {
          id
          title
        }
      }
      ... on FeedbackGivenOnKurssloeyfe {
        elementId
        kurssloeyfe {
          id
          title
        }
      }
      ... on FeedbackGivenOnSimulationCase {
        elementId
        simulationCase {
          id
          title
        }
      }
    }
  }
`;

export const multipleChoiceQuestionFragment = gql`
  fragment MultipleChoiceQuestionFragment on MultipleChoiceQuestion {
    id
    title
    body {
      isMarkdown
      content
    }
    options {
      id
      title
      correct
    }
  }
`;

export const adminStudyProgrammeFragment = gql`
  fragment AdminStudyProgrammeFragment on StudyProgramme {
    id
    status
    title
    description {
      content
      isMarkdown
    }
    elements {
      id
      content {
        id
        status
        title
        ... on ExamSyllabus {
          context {
            id
            title
          }
        }
        ... on Folder {
          type
          context {
            id
            title
          }
        }
      }
    }
  }
`;
